(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cottonil-department"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cd]').forEach(root=>{let favorites=[];try{favorites=JSON.parse(localStorage.getItem('cottonil_favorites')||'[]');if(!Array.isArray(favorites))favorites=[]}catch{}const paint=()=>root.querySelectorAll('.cc-favorite').forEach(b=>b.setAttribute('aria-pressed',String(favorites.includes(b.dataset.productId))));paint();root.addEventListener('click',e=>{const b=e.target.closest('.cc-favorite');if(!b)return;const id=b.dataset.productId;favorites=favorites.includes(id)?favorites.filter(v=>v!==id):[...favorites,id];try{localStorage.setItem('cottonil_favorites',JSON.stringify(favorites))}catch{}paint()})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cottonil-footer"] && !Shopify.designMode) return;
  try {
    const footerMedia=matchMedia('(min-width:768px)');const updateCottonilFooter=()=>document.querySelectorAll('.rf-footer-links').forEach(d=>d.open=footerMedia.matches);updateCottonilFooter();footerMedia.addEventListener('change',updateCottonilFooter);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cottonil-product-design"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cp-product .product-media--variants--root').forEach(gallery=>{const items=gallery.querySelectorAll('.product-media--container>.product-media--root');if(!items.length)return;const label=document.createElement('span');label.className='cp-media-count';gallery.querySelector('.product-media--variants').append(label);const update=()=>{const active=Array.from(items).findIndex(x=>x.dataset.active==='true');label.textContent=`${Math.max(0,active)+1} / ${items.length}`};update();new MutationObserver(update).observe(gallery,{attributes:true,subtree:true,attributeFilter:['data-active']})});

document.querySelectorAll('.cp-favorite').forEach(button=>{let ids=[];try{ids=JSON.parse(localStorage.getItem('cottonil_favorites')||'[]');if(!Array.isArray(ids))ids=[]}catch{}button.setAttribute('aria-pressed',String(ids.includes(button.dataset.productId)));button.addEventListener('click',()=>{const id=button.dataset.productId;ids=ids.includes(id)?ids.filter(v=>v!==id):[...ids,id];try{localStorage.setItem('cottonil_favorites',JSON.stringify(ids))}catch{}button.setAttribute('aria-pressed',String(ids.includes(id)))})});
  } catch(e) { console.error(e); }
})();

})();
